import React, { Fragment, useEffect, useState } from "react";
import MenuBottom from "../../Component/menuBottom/MenuBottom";
import FoodGrouping from "../../Component/FoodGrouping/FoodGrouping";
import Style from "./Restaurants.module.css";
import StoreList from "../../Component/StoreList/StoreList";
import { getRestaurantsList } from "../../Api/BarestServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { getFoodGrouping } from "../../Api/ClientServices";
import { getSearchFoodApi } from "../../Api/ClientServices";
import { Link } from "react-router-dom";
import { errorToast } from "../../Toast/Toast";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const Restaurants = () => {
  const [Resturanfilter, setResturanfilter] = useState("");
  const [Data, setData] = useState();
  const [searchValue, setSearchValue] = useState([]);
  const [showSearchPart, setShowSearchPart] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetRestaurantsData();
  }, []);
  const getSearchSupermarket = async (value) => {
    getSearchFoodApi(value, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast(res.message);
        } else {
          if (res.product?.length === 0 || res.product === null) { 
            setShowSearchPart(false);
          } else {
            setSearchValue(res.product);
            setShowSearchPart(true);
          }
        }
      } else {
        console.error(res);
      }
    });
  };
  const GetRestaurantsData = async () => {
    getRestaurantsList((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast(res.message);
        } else {
          setData(res.suppliers);
        }
      } else {
        console.error(res);
      }
    });
  };

  const filterProduct = (categoryName) => {
    setLoading(true);
    getFoodGrouping(categoryName, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast(res.message);
        } else {
          setData(res.suppliers);
        }
      } else {
        console.error(res);
      }
    });
    setLoading(false);
  };
  let LoadingHolder = null;
  if (Data === undefined || loading) {
    LoadingHolder = (
      <PointSpreadLoading
        style={{ top: "13rem" }}
        color={"#ab0c59"}
        size={"small"}
      />
    );
  } else {
    LoadingHolder = (
      <StoreList searchInput={Resturanfilter} data={Data} splice={false} />
    );
  }
  return (
    <Fragment>
      <div className={Style.fixPage}>
        <div className={Style.ContentHolder}>
          <div className={Style.searchHolder}>
            <input
              className={Style.search}
              placeholder={"جستجو..."}
              onChange={(e) => getSearchSupermarket(e.target.value)}
              type={"text"}
            />
            {!showSearchPart ? null : (
              <ul className={Style.searchResult}>
                {searchValue?.map((item, index) => {
                  return (
                    <Link
                      to={{
                        pathname: `/product/${item.id}/${item.supplier_id}`,
                        state: item.id,
                      }}
                      className={Style.resultItem}
                      key={index}
                    >
                      <div className={Style.imgHolder}>
                        <img
                          src={`https://cdn.barest.ir/product/m/${item.id}.jpg`}
                          alt={item.name}
                        />
                      </div>
                      <div className={Style.productInfo}>
                        <h3 className={Style.productName}>{item.name}</h3>
                        <div className={Style.priceHolder}>
                          {item.off_price === 0 ? null : (
                            <h3 className={Style.offPrice}>
                              {item.off_price}تومان
                            </h3>
                          )}
                          {item.off_price === 0 ? (
                            <h3 className={Style.price}>{item.price}تومان</h3>
                          ) : (
                            <h3 className={Style.ofprice}>{item.price}تومان</h3>
                          )}
                        </div>
                      </div>
                    </Link>
                  );
                })}
                <div className={Style.opacityPart}></div>
              </ul>
            )}
          </div>
          <div className={Style.categoryHolder}>
            <h3 className={Style.categoryTitle}>دسته بندی غذاها</h3>
            <FoodGrouping filterProduct={filterProduct} />
          </div>
          <div className={Style.titleHolder}>
            <h3 className={Style.restaurantList}> لیست رستوران ها </h3>
            <div className={Style.SearchResturanDiv}>
              <input
                type="search"
                placeholder="جست و جو..."
                className={Style.searchInput}
                onChange={(e) => setResturanfilter(e.target.value)}
              />
              <FontAwesomeIcon icon={faSearch} color="#ffffff" />
            </div>
          </div>
          {LoadingHolder}
        </div>
      </div>
      <MenuBottom />
    </Fragment>
  );
};

export default Restaurants;
